// src/layouts/MainLayout.js
import React, { useEffect, useContext } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { AuthContext } from '../contexts/AuthContext';

function MainLayout() {
  const location = useLocation();
  const { currentUser } = useContext(AuthContext);
  
  // Determine if the current path should use the dashboard layout
  const isDashboardPath = location.pathname.includes('/dashboard') || 
                        location.pathname.includes('/profile') || 
                        location.pathname.includes('/record') ||
                        location.pathname.includes('/admin');

  useEffect(() => {
    if (location.state?.scrollTo) {
      const section = location.state.scrollTo;
      document.getElementById(section)?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [location]);

  // Hide navigation elements for authenticated users on dashboard-related paths
  const shouldShowNavbar = !currentUser || !isDashboardPath;
  const shouldShowFooter = !currentUser || !isDashboardPath;

  // Special case for public video landing pages - always show footer
  const isVideoLandingPage = location.pathname.includes('/introreel/');
  
  return (
    <>
      {shouldShowNavbar && <Navbar />}
      {/* Main Content */}
      <Outlet />
      {(shouldShowFooter || isVideoLandingPage) && <Footer />}
    </>
  );
}

export default MainLayout;
